import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatNumberToCurrency({
  number,
  showCurrency = true,
  locale = "nl-NL",
}: {
  number: number;
  showCurrency?: boolean;
  locale?: string;
}) {
  return new Intl.NumberFormat(locale, {
    style: showCurrency ? "currency" : "decimal",
    currency: showCurrency ? "EUR" : undefined,
    minimumFractionDigits: 2,
  }).format(number);
}

export const generateRandomString = (length: number) => {
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * characters.length));
  }
  return result;
};

export const getDeliveryFee = (
  deliveryAreaFee: number,
  freeDeliveryFrom: number | undefined,
  orderTotal: number
) => {
  if (freeDeliveryFrom && orderTotal >= freeDeliveryFrom) {
    return 0;
  }
  return deliveryAreaFee;
};

export function getTextColor(bgColor?: string): string | undefined {
  if (!bgColor) return undefined;

  // Remove any leading '#' character from the text color if present
  const cleanColor = bgColor.replace("#", "");

  // Convert the text color to RGB values
  const r = parseInt(cleanColor.slice(0, 2), 16);
  const g = parseInt(cleanColor.slice(2, 4), 16);
  const b = parseInt(cleanColor.slice(4, 6), 16);

  // Calculate the brightness of the text color using a simple formula
  const brightness = (r * 299 + g * 587 + b * 114) / 1000;

  // Determine the background color based on the brightness
  if (brightness > 127) {
    return "#000000"; // Dark background color for bright text
  } else {
    return "#FFFFFF"; // Light background color for dark text
  }
}
